import { findOne } from 'rcd-cpp-workspace/utils/array';
import * as React from 'react';
import { FilterProps } from '../filters';
import './textFilter.scss';
import { Op } from '../../../enums/Op';
import { parseCondition } from '../../../utils';
import { Options } from '../Options/options';
import { ReferenceInput } from '../RefereceInput/referenceInput';

const OPTIONS = [
  Op.refIds,
  Op.notRefIds,
  Op.contains,
  Op.doesNotContain,
  Op.startsWith,
  Op.endsWith,
  Op.isEmpty,
  Op.isNotEmpty
];

const InputOpts = [Op.contains, Op.doesNotContain, Op.startsWith, Op.endsWith];
const SearchOpts = [Op.refIds, Op.notRefIds];
const BooleanOpts = [Op.isEmpty, Op.isNotEmpty];
const isSameType = (op1: Op, op2: Op): boolean => {
  for (const t of [InputOpts, SearchOpts, BooleanOpts]) {
    if (t.includes(op1) && t.includes(op2)) {
      return true;
    }
  }
  return false;
};

export const TextFilter = ({
  filter,
  field,
  schema,
  cache,
  setFilter,
  filters,
  preappliedFilters
}: FilterProps) => {
  const curFilter = filter; //findOne(filters, { field: filter.field });
  const options = OPTIONS.filter(o => {
    if (filter.field == 'Comment.message') {
      return o == Op.isEmpty || o == Op.isNotEmpty;
    }
    if (o == Op.refIds || o == Op.notRefIds) {
      return schema.props.displayField == field.field;
    }
    return true;
  });
  const { op, val } = parseCondition(
    curFilter.conditions,
    filter.field == 'Item.title'
      ? Op.contains
      : filter.field == 'Comment.message'
      ? ('Select...' as any)
      : options[0]
  );
  return (
    <div className="filter-box text-filter tree-filter">
      <div>
        {field.name}&nbsp;
        <Options
          options={options}
          onSelect={o => {
            if ([Op.isEmpty, Op.isNotEmpty].includes(o)) {
              setFilter({ ...curFilter, conditions: [{ [o]: true }] });
            } else {
              if (isSameType(o, op)) {
                setFilter({ ...curFilter, conditions: [{ [o]: val }] });
              } else {
                setFilter({ ...curFilter, conditions: [{ [o]: null }] });
              }
            }
          }}
          selected={op}
        />
      </div>
      <div>
        {InputOpts.includes(op) && (
          <input
            type="text"
            className="form-control"
            value={val}
            onChange={(e: any) => {
              setFilter(
                { ...curFilter, conditions: [{ [op]: e.target.value }] },
                true
              );
            }}
          />
        )}
        {SearchOpts.includes(op) && (
          <ReferenceInput
            selected={val}
            cache={cache}
            filters={filters}
            preappliedFilters={preappliedFilters}
            field={filter.field}
            onChange={values => {
              setFilter({ ...curFilter, conditions: [{ [op]: values }] }, true);
            }}
          />
        )}
      </div>
    </div>
  );
};
